// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__5mg+Y","logo":"Logo_logo__7jxcm"};